import { Box, Typography } from '@mui/material';
import ProcessSteps from '../../../../components/ProcessSteps';
import AgencyCompanyAnimate from '../Animate/mobile';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  textMonarcha: {
    fontFamily: 'monarcha,open-sans !important',
    textTransform: 'uppercase !important',
    color: 'white ',
    fontWeight: 'bold !important',
  },
  textOpenSans: {
    fontFamily: 'open-sans,san-serif !important',
    textTransform: 'normal',
    color: 'white',
  },
}));

export default function StepsContent__desktop(props) {
  const { index, setIndex, stepsNames, stepDescription, scale } = props;

  const classes = useStyles();

  return (
    <Box sx={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-evenly' }}>
      <div style={{ zIndex: 5, margin: ' 0', width: 'fit-content' }}>
        <ProcessSteps
          process
          index={index}
          setIndex={setIndex}
          length={stepsNames.length}
          stepsNames={stepsNames}
        />
      </div>

      <div
        style={{
          position: 'relative',
          width: 'min-content',
          margin: index === 2 ? '0 auto 7px' : '0 auto 20px',
        }}
      >
        <AgencyCompanyAnimate index={index} fontStyle={classes.textMonarcha} />
        <div
          style={
            {
              // position: 'absolute',
              // bottom: index === 1 ? '-73%' : index === 3 ? '-50px' : '-70px',
              // left: index === 1 ? '0%' : index === 3 ? '0' : '-150%',
              // width: '100%',
              // height: '100%',
            }
          }
        >
          {stepDescription[index]}
        </div>
        {index === 2 && (
          <div
            style={{
              position: 'absolute',
              bottom: '-106%',
              left: '1%',
              width: '100%',
              height: '100%',
            }}
          >
            <Typography
              className={classes.textMonarcha}
              sx={{
                color: '#909090',
                width: 'max-content',
                textAlign: 'center',
                position: 'absolute',
                // top: '5%',
                // left: '-28%',
                top: '5px',
                left: '-80px',
                fontSize: '12px',
                lineHeight: 1.2,
              }}
            >
              {' '}
              When your <br />
              <span style={{ color: '#ffbf12' }}>creators’ Shoutout sales</span> and/or <br />
              <span style={{ color: '#ffbf12' }}>their social media
                engagement go up</span>,<br /> your creator agency
              <br />
              <span style={{ color: '#ffbf12' }}>value goes up.</span>
            </Typography>
          </div>
        )}
        <div
          style={{
            width: '80vw',
            position: 'absolute',
            bottom: index === 0 ? '-48%' : '-76%',
            right: index === 0 ? '0%' : '-14%',
            transform: 'translate(0%,0)',
          }}
        > {index === 0 && (
          <Typography
            className={classes.textOpenSans}
            sx={{
              color: '#707070',
              fontSize: '12px',
              lineHeight: 1.3,
              fontWeight: 'lighter',
              margin: '0 auto',
              maxWidth: '370px',
            }}
          >

            *No registered business is required to start generating revenue on PassionStocks. <br />
            PassionStocks does not provide legal, financial, or accounting advice. Always consult a professional or use PassionStocks’ recommended third-party services for trademarks, contracts, or other legal and financial matters.
            These recommendations are not endorsements but suggestions for your convenience.
          </Typography>)}
        </div>
      </div>
    </Box>
  );
}
